import React from 'react';
import Reflux from 'reflux';
import keyIn from 'shared/lib/immutable/keyIn';

import UIRegions from 'shared/constants/UIRegions';
import { RowTypes } from 'flux/stores/cuesheet/CuesheetConstants';

import { Row, Col, Button } from 'bootstrap';
import Modal from 'shared/components/misc/modal.jsx';

import ModalActions from 'flux/actions/ModalActions';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import CuesheetResponsiveStore from 'flux/stores/cuesheet/CuesheetResponsiveStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import ConfirmActions from 'flux/actions/ConfirmActions';

import { DisplayForAdmin } from 'shared/components/misc/displayForRole.jsx';
import Tappable from 'react-tappable';
import RowMenuColorsMixin from 'main/components/show/cuesheet/itemCell/rowMenuColorsMixin.jsx';

import role from 'shared/lib/role';

export default React.createClass({
  mixins: [
    Reflux.connectFilter(CuesheetResponsiveStore, 'rowIndex', (st) =>
      st.get('rowMenuVisibleFor'),
    ),
    Reflux.connectFilter(CuesheetStore, 'cuesheet', (state) =>
      state.filter(keyIn('pasteMode', 'rows', 'rowMap')),
    ),
    RowMenuColorsMixin,
  ],

  contextTypes: {
    user: React.PropTypes.object,
    router: React.PropTypes.object.isRequired,
  },

  displayName: 'CueMenuModal',

  render() {
    return (
      <Modal className="csr-modal-row-menu-wrapper" name={this._getModalId()}>
        {this._getMenuNode()}
      </Modal>
    );
  },

  _getMenuNode() {
    let { params } = this.context.router.state;

    return (
      <div className="csr-modal-menu-content">
        <div className="csr-modal-menu-highlights">
          <DisplayForAdmin {...params}>
            <div id="global-highlight-mobile">
              <div className="csr-modal-menu-highlights-title">
                Global Highlight
              </div>
              {this.getGlobalHighlightsNode()}
            </div>
          </DisplayForAdmin>
          <div id="personal-highlight-mobile">
            <div className="csr-modal-menu-highlights-title">
              Personal Highlight
            </div>
            {this.getPersonalHighlightsNode()}
          </div>
        </div>
        <DisplayForAdmin {...params}>
          {this._getMenuButtonNodes()}
        </DisplayForAdmin>
      </div>
    );
  },

  _getMenuButtonNodes() {
    let gridProps = {
      lg: 12,
      md: 12,
      sm: 12,
      xs: 12,
    };

    return (
      <Row>
        <Col {...gridProps}>{this._getMoveUpButtonNode()}</Col>
        <Col {...gridProps}>{this._getMoveDownButtonNode()}</Col>
        <Col {...gridProps}>
          <Tappable onTap={() => this._addItemRowAbove()}>
            <Button>Add Row Above</Button>
          </Tappable>
        </Col>

        <Col {...gridProps}>
          <Tappable onTap={() => this._duplicateRow()}>
            <Button>Duplicate Row</Button>
          </Tappable>
        </Col>
        <Col {...gridProps}>
          <Tappable onTap={() => this._deleteRow()}>
            <Button>Delete Row</Button>
          </Tappable>
        </Col>
        <Col {...gridProps}>{this._getCopyRowButtonNode()}</Col>
        <Col {...gridProps}>{this._getCutRowButtonNode()}</Col>
        <Col {...gridProps}>{this._getPasteRowAboveButtonNode()}</Col>
        <Col {...gridProps}>{this._getPasteRowBelowButtonNode()}</Col>
        <Col {...gridProps}>{this._getTitleRowButtonNode()}</Col>
        <Col {...gridProps}>{this._getItemRowButtonNode()}</Col>
        <Col {...gridProps}>{this._getLockRowButtonNode()}</Col>
        <Col {...gridProps}>{this._getUnlockRowButtonNode()}</Col>
        {this._getTrackButtonNode()}
      </Row>
    );
  },

  _getTrackButtonNode() {
    let { params } = this.context.router.state;
    let hasEventShowCaller = role.hasEventShowCallerRole(
      this.context.user,
      params.eventId,
    );

    if (!hasEventShowCaller) return null;

    return (
      <Col lg={24} md={24} sm={24} xs={24}>
        <Tappable onTap={() => this._trackRow()}>
          <div className="csr-modal-btn-track-row">
            <Button>Track Row</Button>
          </div>
        </Tappable>
      </Col>
    );
  },

  _getMoveUpButtonNode() {
    return (
      <Tappable
        onTap={() => {
          ModalActions.hide(this._getModalId());
          CuesheetRowActions.moveItemRowUp(this.state.rowIndex);
        }}
      >
        <Button>Move Up</Button>
      </Tappable>
    );
  },

  _getMoveDownButtonNode() {
    return (
      <Tappable
        onTap={() => {
          ModalActions.hide(this._getModalId());
          CuesheetRowActions.moveItemRowDown(this.state.rowIndex);
        }}
      >
        <Button>Move Down</Button>
      </Tappable>
    );
  },

  _getUnlockRowButtonNode() {
    if (!this._isLockedRow()) return null;

    return (
      <Tappable onTap={() => this._toggleRowLock()}>
        <Button>Unlock Row</Button>
      </Tappable>
    );
  },

  _getLockRowButtonNode() {
    if (this._isLockedRow()) return null;

    return (
      <Tappable onTap={() => this._toggleRowLock()}>
        <Button>Lock Row</Button>
      </Tappable>
    );
  },

  _getTitleRowButtonNode() {
    if (this._isTitleRow()) return null;

    return (
      <Tappable onTap={() => this._convertTitleRow()}>
        <Button>Make Title Row</Button>
      </Tappable>
    );
  },

  _getItemRowButtonNode() {
    if (!this._isTitleRow()) return null;

    return (
      <Tappable onTap={() => this._convertItemRow()}>
        <Button>Make Item Row</Button>
      </Tappable>
    );
  },

  _getCopyRowButtonNode() {
    return (
      <Tappable onTap={() => this._copyRow()}>
        <Button>Copy Row</Button>
      </Tappable>
    );
  },

  _getCutRowButtonNode() {
    return (
      <Tappable onTap={() => this._cutRow()}>
        <Button>Cut Row</Button>
      </Tappable>
    );
  },

  _getPasteRowAboveButtonNode() {
    if (!this.state.cuesheet.get('pasteMode')) return null;

    return (
      <Tappable onTap={() => this._pasteRowAbove()}>
        <Button>Paste Row Above</Button>
      </Tappable>
    );
  },

  _getPasteRowBelowButtonNode() {
    if (!this.state.cuesheet.get('pasteMode')) return null;

    return (
      <Tappable onTap={() => this._pasteRowBelow()}>
        <Button>Paste Row Below</Button>
      </Tappable>
    );
  },

  _addItemRowAbove() {
    ModalActions.hide(this._getModalId());
    CuesheetRowActions.addItemRowAbove(this.state.rowIndex);
  },

  _trackRow() {
    ModalActions.hide(this._getModalId());
    CuesheetRowActions.trackRow(this.state.rowIndex);
  },

  _duplicateRow() {
    ModalActions.hide(this._getModalId());
    CuesheetRowActions.duplicateItemRow(this.state.rowIndex);
  },

  _deleteRow() {
    ModalActions.hide(this._getModalId());
    ConfirmActions.prompt(
      'Are you sure you want to remove this item row?',
      () => CuesheetRowActions.deleteItemRow(this.state.rowIndex),
    );
  },

  _copyRow() {
    ModalActions.hide(this._getModalId());
    CuesheetRowActions.addRowToPasteBuffer(this.state.rowIndex);
  },

  _cutRow() {
    ModalActions.hide(this._getModalId());
    CuesheetRowActions.addRowToCutBuffer(this.state.rowIndex);
  },

  _pasteRowAbove() {
    ModalActions.hide(this._getModalId());
    CuesheetRowActions.pasteBufferAbove(this.state.rowIndex);
  },

  _pasteRowBelow() {
    ModalActions.hide(this._getModalId());
    CuesheetRowActions.pasteBufferBelow(this.state.rowIndex);
  },

  _convertTitleRow() {
    ModalActions.hide(this._getModalId());
    CuesheetRowActions.convertToTitleRow(this.state.rowIndex);
  },

  _convertItemRow() {
    ModalActions.hide(this._getModalId());
    CuesheetRowActions.convertToStandardRow(this.state.rowIndex);
  },

  _toggleRowLock() {
    ModalActions.hide(this._getModalId());
    CuesheetRowActions.toggleRowLock(this.state.rowIndex);
  },

  _getModalId() {
    return UIRegions.CuesheetItemMenu;
  },

  _isTitleRow() {
    let rowIndex = this.state.rowIndex;

    return (
      this.state.cuesheet.getIn(['rows', rowIndex, 'type']) ===
      RowTypes.TitleItem
    );
  },

  _isLockedRow() {
    let rowIndex = this.state.rowIndex;
    let state = this.state.cuesheet;

    if (!state.get('rowMap') || (!rowIndex && rowIndex !== 0)) return false;

    let path = state.getIn(['rows', rowIndex, 'path']);
    let item = state.getIn(['rowMap'].concat(path));

    if (!item) return false;

    return item.get('locked');
  },
});
